import { ClosingCta } from "@frontend/components/site/closing-cta";
import { Features } from "@frontend/components/site/features";
import { branding } from "@creators/backend/lib/config";
import { Seo } from "@frontend/lib/seo";
import { useViewer } from "@frontend/lib/viewer";

const DESCRIPTION =
  "Pinned terms, staged payments, and clocks on every step — what you get when brands book you through Send Collab.";

export function FeaturesPage() {
  const { viewer } = useViewer();
  const signedIn = Boolean(viewer && !viewer.isAdmin);

  return (
    <main>
      <Seo
        title={`What you get — ${branding.name}`}
        description={DESCRIPTION}
        path="/features"
      />
      <Features />
      <ClosingCta signedIn={signedIn} />
    </main>
  );
}
